import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * Soft pastel status pill, matching the broader application's neutral chip style.
 * Used for Active / Inactive flags on client and team tables and detail dialogs.
 */
const StatusChip = ({ active, activeLabel = 'Active', inactiveLabel = 'Inactive', size = 'small' }) => {
    const padY = size === 'small' ? '2px' : '4px';
    const padX = size === 'small' ? '8px' : '12px';
    const fontSize = size === 'small' ? 12 : 13;

    return (
        <Box
            component="span"
            sx={(theme) => {
                const isLight = theme.palette.mode === 'light';
                const activeBg = alpha(theme.palette.success.main, 0.12);
                const activeBorder = alpha(theme.palette.success.main, 0.28);
                const activeColor = theme.palette.getContrastText(theme.palette.success.main);

                const inactiveBg = isLight ? theme.palette.grey[100] : theme.palette.grey[800];
                const inactiveBorder = isLight ? theme.palette.grey[300] : theme.palette.grey[700];
                const inactiveColor = theme.palette.text.secondary;

                const bg = active ? activeBg : inactiveBg;
                const borderColor = active ? activeBorder : inactiveBorder;
                const isDark = theme.palette.mode === 'dark';
                const color = isDark ? theme.palette.common.white : (active ? activeColor : inactiveColor);

                return {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.75,
                    px: padX,
                    py: padY,
                    borderRadius: '999px',
                    bgcolor: bg,
                    color,
                    border: '1px solid',
                    borderColor,
                    fontSize,
                    fontWeight: 600,
                    lineHeight: 1.2,
                    whiteSpace: 'nowrap'
                };
            }}
        >
            <Box
                component="span"
                sx={(theme) => ({
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    bgcolor: active ? theme.palette.success.main : theme.palette.text.secondary,
                    display: 'inline-block'
                })}
            />
            {active ? activeLabel : inactiveLabel}
        </Box>
    );
};

export default StatusChip;
